import React, { Component } from 'react';
import {Checkbox} from "material-ui";
import BatteryStatus from '../Status/Battery';
import TemperatureStatus from '../Status/Temperature';
import PartialStatus from '../Status/Partial';
import VisitsStatus from '../Status/Visits';
import IssuesStatus from '../Status/Issues';
import CanceledDeliveriesStatus from '../Status/CanceledDeliveries';
import Gravatar from 'react-gravatar';

import Formatter from '../../psuite-js/helpers/formatter';
import moment from "moment/moment";
import _ from "lodash";
import VehiclesHelper from '../../helpers/Vehicles';
import {inject, observer} from "mobx-react";

class MonitorinListItem extends Component {
    state = {
        isHovering: false,
    };

    handleMouseHover = () => {
        this.setState(this.toggleHoverState);
    };

    toggleHoverState(state) {
        return {
            isHovering: !state.isHovering,
        };
    }

    render() {
        const { document, app_store } = this.props;
        const vehicle = document.vehicle || {};
        const user = vehicle.user || {};
        // const vehicle_contract = vehicle.vehicle_contract || {};
        // const vehicle_type = vehicle.vehicle_type || {};
        const weight_occupation = document.weight_occupation;
        const delivery_type = document.delivery_type || {};
        const show_temperature = VehiclesHelper.isCool(vehicle);
        const temperature = document.temperature || {};
        const location = document.location || {};

        const location_payload = location.payload || {};
        const device = location_payload.device || {};
        const vehicle_device = document.vehicle_device || {};

        const phones = user.phones || {};

        let deliveries = Object.assign([], document.deliveries);
        let orderly_deliveries = _.sortBy(deliveries, 'delivery_eta_at');
        let delivery_eta_at = (orderly_deliveries.length) ? orderly_deliveries[orderly_deliveries.length - 1].delivery_eta_at : null;

        return (
            <tr key={document.id} id={document.id} onClick={() => {
                if (this.state.isHovering) {
                    this.props.onSelectItem(document);
                } else {
                    this.props.gotoMonitoringDelivery(document)
                }
            }}>
                <td>
                    <div className="user-info">
                        <div className={'selectable-container'}
                             onMouseEnter={this.handleMouseHover}
                             onMouseLeave={this.handleMouseHover}>
                            {(this.state.isHovering || this.props.selectedItems.length > 0) &&
                                <Checkbox
                                    checked={this.props.selectedItems.indexOf(document.id) !== -1}
                                    onChange={() => {this.props.onSelectItem(document)}}
                                    className={'checkbox'}/>
                            }
                            <div className={'gravatar-container'}>
                                {!this.state.isHovering && !this.props.selectedItems.length > 0 &&
                                    <Gravatar email={user.email || 'unknow@polibrasnet.com.br'} size={32} default="mm" className="avatar" />
                                }
                            </div>

                        </div>
                        <div style={{display: 'flex', alignItems: 'center', marginLeft: 10}}>
                            <div>
                                <h4>{user.display_name}</h4>
                                <small>{Formatter.formatPhone(phones.main)}</small>
                            </div>
                        </div>
                    </div>
                </td>

                <td>{document.id}</td>
                <td>{ delivery_eta_at ? moment(delivery_eta_at).format('DD/MM/YYYY') : 'Sem previsão'}</td>
                <td>{vehicle.id} ({weight_occupation}%)</td>
                <td>{delivery_type.name}</td>

                {
                    app_store.configurations.use_temperature && (
                        <td><TemperatureStatus show={show_temperature} vehicleDevice={vehicle_device} temperature={temperature} /></td>
                    )
                }

                <td><BatteryStatus battery={device.battery} /></td>

                <td><PartialStatus id={document.id} /></td>

                <td><VisitsStatus id={document.id} /></td>

                <td>
                    <div className="td-container">
                        <CanceledDeliveriesStatus document={document} />
                        <IssuesStatus document={document} />
                    </div>
                </td>
            </tr>
        )
    }
}

let container = observer(MonitorinListItem);
container = inject(['app_store'])(container);

export default container;



// WEBPACK FOOTER //
// ./src/components/Monitoring/MonitorinListItem.js